import { Component, ElementRef, ViewChild, OnInit, Compiler} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { GridOptions } from "ag-grid";
import { ConsigmentUploadService } from 'app/d2z/service/consignment-upload.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import * as XLSX from 'xlsx';
declare var $: any;
interface dropdownTemplate {
  name: string;
  value: string;
}

@Component({
  selector: 'update-weight',
  templateUrl: './update-weight.component.html',
  styleUrls: ['./update-weight.component.css']
})

export class UpdateWeightComponent implements OnInit{
 inputForm: FormGroup;
 public importList = [];

  
  manifestNumber: string;
  arrayBuffer:any;
  file:File;
  errorMsg: string;
  show: Boolean;
  ReferenceFlag; Boolean;
  ArticleFlag: Boolean;
  successMsg: String;
  userName: String;
  system: String;
  role_id: String;
   gridOptions: GridOptions;
   autoGroupColumnDef;
   rowGroupPanelShow;
   rowData: any[];
   defaultColDef;
  shipmentAllocateForm: FormGroup;
  exportTypeDropdown: dropdownTemplate[];  
  selectedExportType: dropdownTemplate;
  constructor(
    public consigmentUploadService: ConsigmentUploadService,
    private spinner: NgxSpinnerService,
  ) {
    this.inputForm = new FormGroup({
      isWeight: new FormControl(true),
      isDescription: new FormControl(false),
      identifier: new FormControl('D2Z'),
    });

    this.gridOptions = <GridOptions>{ rowSelection: "multiple" };
    this.gridOptions.columnDefs = [
      {
        headerName: "Article ID",
        field: "articleid",
        width: 300,
        checkboxSelection: true,
        headerCheckboxSelection: function(params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        }
      },
      {
        headerName: "Weight",
        field: "weight",
        width: 250
      },
        {
        headerName: "Description",
        field: "description",
        width: 400
      }
    ];

  }

  ngOnInit() {
    this.getLoginDetails();
    
  };

  

  getLoginDetails(){
    if(this.consigmentUploadService.userMessage != undefined){
      this.userName = this.consigmentUploadService.userMessage.userName;
      this.role_id = this.consigmentUploadService.userMessage.role_Id;
    }
  };
  
  incomingfile(event) {
    this.successMsg = "";
    this.errorMsg = "";
    this.rowData = [];
    this.file = event.target.files[0]; 
    this.uploadArticleID();
  };

  uploadArticleID(){
    var worksheet;
      this.errorMsg = null;
      let fileReader = new FileReader();
      this.importList= [];
      fileReader.readAsArrayBuffer(this.file);
      let ArticleID   ='articleid'; 
      let Weigh = 'weight'  ;
      let description = 'description';
      fileReader.onload = (e) => {
           this.arrayBuffer = fileReader.result;
          var data = new Uint8Array(this.arrayBuffer);
          var arr = new Array();
          for(var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          var bstr = arr.join("");
          var workbook = XLSX.read(bstr, {type:"binary"});
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var exportData = XLSX.utils.sheet_to_json(worksheet);
          for (var importVal in exportData) {
            var dataObj = exportData[importVal];
            console.log(dataObj);
            if(this.errorMsg == null){
              var importObj = (
                importObj={}, 
                importObj[ArticleID]= dataObj['Article ID'] != undefined ? dataObj['Article ID'] : '', importObj,
                importObj[Weigh]= dataObj['Weight'] != undefined ? dataObj['Weight'] : '', importObj,
                importObj[description]= dataObj['Description'] != undefined ? dataObj['Description'] : '', importObj
              );
              this.importList.push(importObj)
              console.log(this.importList);
              this.rowData = this.importList;
              }
          }
        }
  };
  uploadWeight(){
    console.log(this.inputForm.value.isWeight)
    console.log(this.inputForm.value.isDescription)
   
    var selectedweight = this.gridOptions.api.getSelectedRows();
    if(selectedweight.length > 0){
    for (var weightrow in selectedweight) {
      var approveObj = selectedweight[weightrow];
      console.log(approveObj);
    }
    this.spinner.show();
     if(this.inputForm.value.isWeight){
      this.consigmentUploadService.uploadweight(selectedweight,this.inputForm.value.identifier,  (resp) => {
          if(!this.inputForm.value.isDescription){this.spinner.hide();
          this.successMsg = resp.message;
          console.log(resp);
        }
      });
    } if(this.inputForm.value.isDescription){
      this.consigmentUploadService.uploadDescription(selectedweight,  (resp) => {
          this.spinner.hide();
          this.successMsg = resp.message;
          console.log(resp);
      });
    }
    }else{
      this.errorMsg =  "**Please select the below records to upload";
    }
  
  };

 

  onSelectionChange() {
    var selectedRows = this.gridOptions.api.getSelectedRows();
    this.errorMsg = null;
  };
}





// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/create-shipment/update-weight/update-weight.component.ts